/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  const $bar = $('.anchor-section');
  if (!$bar.length) return;

  const $buttons = $bar.find('.anchor-section__item');
  const $inner = $bar.find('.anchor-section__inner');
  const $header = $('header');
  // The mega-menu panel sits inside <header> in normal flow, so opening it grows
  // the header's box. Measure the nav row instead, which the panel drops below.
  const $headerRow = $('.desk_header-container');
  const $headerRef = $headerRow.length ? $headerRow : $header;

  function getHeaderHeight() {
    return $headerRef.length ? $headerRef[0].getBoundingClientRect().bottom : 0;
  }

  let lastBottom = -1;

  function updateBarPosition() {
    const headerBottom = $headerRef.length ? $headerRef[0].getBoundingClientRect().bottom : 0;
    const bottom = Math.max(0, headerBottom);
    if (bottom !== lastBottom) {
      lastBottom = bottom;
      $bar.css('top', bottom + 'px');
    }
  }

  function scrollActiveIntoView($activeBtn) {
    if (!$activeBtn || !$activeBtn.length || !$inner.length) return;
    const inner = $inner[0];
    const btn = $activeBtn[0];
    const innerRect = inner.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    const btnLeft = btn.offsetLeft;
    const btnRight = btnLeft + btn.offsetWidth;
    const visibleLeft = inner.scrollLeft;
    const visibleRight = visibleLeft + inner.offsetWidth;
    if (btnLeft < visibleLeft + 16) {
      inner.scrollTo({ left: btnLeft - 16, behavior: 'smooth' });
    } else if (btnRight > visibleRight - 16) {
      inner.scrollTo({ left: btnRight - inner.offsetWidth + 16, behavior: 'smooth' });
    }
  }

  function updateActive() {
    if (!$bar.hasClass('anchor-showed')) return;

    const barH = $bar.outerHeight();
    const offset = getHeaderHeight() + barH + 60;
    let $active = null;

    $buttons.each(function () {
      const $el = $('#' + $(this).data('target'));
      if (!$el.length) return;
      const rect = $el[0].getBoundingClientRect();
      if (rect.top <= offset && rect.bottom > offset) {
        $active = $(this);
      }
    });

    $buttons.removeClass('is-active');
    if ($active) {
      $active.addClass('is-active');
      scrollActiveIntoView($active);
    }
  }

  function loop() {
    updateBarPosition();
    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);

  const firstTargetId = $buttons.first().data('target');
  const $firstSection = $('#' + firstTargetId);

  if ($firstSection.length) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    $firstSection.css('position', 'relative').prepend(sentinel);

    new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        $bar.addClass('anchor-showed');
        setTimeout(updateActive, 60);
      } else {
        // Top of the page (first section's top in view) — keep the first button (its own
        // section) highlighted instead of clearing everything.
        $bar.removeClass('anchor-showed');
        $buttons.removeClass('is-active');
        $buttons.first().addClass('is-active');
      }
    }, {
      rootMargin: `-${parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-padding')) || 60}px 0px 0px 0px`,
      threshold: 0
    }).observe(sentinel);
  }

  $(window).on('scroll', updateActive);

  $buttons.on('click', function () {
    const $target = $('#' + $(this).data('target'));
    if (!$target.length) return;

    const barH = $bar.outerHeight();
    const top = $target.offset().top - getHeaderHeight() - barH;

    if (window.lenis) {
      window.lenis.scrollTo(top, { duration: 0.8 });
    } else {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });

  $(document).ready(function () {
    updateActive();
  });
})();